import { UPDATE_TASK, UPDATE_TASK_STATUS } from '../../../../api';
import { InsuranceCertificateFormValues, UpdateTaskCompletionDataInput } from '../types';
import { useState } from 'react';
import { Task } from '@trnsact/trnsact-shared-types';
import { useUpsertDocument } from '../../../../hooks/useUpsertDocument';
import { useMutation } from '@apollo/client';
import { TaskStatuses } from '../../../../api/types';


export const useInsuranceVerificationSubmit = () => {

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const { upsertDocument } = useUpsertDocument();

  const [updateTask] = useMutation(UPDATE_TASK);
  const [updateTaskStatus] = useMutation(UPDATE_TASK_STATUS);

  const submit = async (task: Task, values: InsuranceCertificateFormValues, refetchTask: any) => {
    try {
      setIsLoading(true);
      const taskItem = task.taskItems?.find(ti => ti?.docType === 'insurance certificate');
      const documentInput = {
        vendorOpportunityId: task.vendorOpportunityId,
        creditSubId: task.creditSubId,
        source: 'Insurance Verification Task Page',
        createdBy: 'Applicant',
        docDescription: 'Uploaded By Insurance Broker',
        docType: 'insurance certificate',
        docName: 'Insurance Certificate',
        taskItemId: taskItem?.taskItemId,
        dealerAccess: true,
        lenderAccess: false,
      };
      const documentId = await upsertDocument(values.file!, documentInput);
      if (!documentId) {
        throw (`Couldn't upload document`);
      }
      const taskInput: UpdateTaskCompletionDataInput = {
        completionData: {
          name: values.name,
          title: values.title,
          signature: values.signature,
          additionalInformation: values.additionalInformation,
        },
        //taskItems: [taskItem]   // Cannot set taskItems as they will be overwritten on the backend, causing the document to lose its link to the taskItem
      };
      await updateTask({
        variables: {
          taskId: task.taskId,
          input: taskInput
        },
      });
      await updateTaskStatus({
        variables: {
          taskId: task.taskId,
          status: TaskStatuses.Complete
        },
      });
      await refetchTask();
      setIsLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  return {
    isLoading,
    submit,
  };
};
